"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeaderBarLinks = _ref => {
  let {
    profilePath
  } = _ref;
  return _SecurityContextHolder.SecurityContextHolder.isAuthenticated() && /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-header"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: profilePath,
    activeClassName: "is-active",
    className: "navbar-item navbar-item--is-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-text"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "person")), /*#__PURE__*/_react.default.createElement("span", {
    className: "is-hidden-desktop"
  }, "Profile"))));
};
HeaderBarLinks.propTypes = {
  profilePath: _propTypes.default.string
};
HeaderBarLinks.defaultProps = {
  profilePath: null
};
var _default = exports.default = HeaderBarLinks;
//# sourceMappingURL=HeaderBarLinks.js.map